import React, { useCallback } from "react";
import { Button } from "components";
import {
  useActiveTab,
  useSetActiveTab,
  ConfiguratorTabs,
} from "stores/product";
import { useTranslate } from "hooks";

export const ToggleTechnicalTabButton = () => {
  const translate = useTranslate();
  const setActiveTab = useSetActiveTab();
  const activeTab = useActiveTab();

  const onClick = useCallback(() => {
    setActiveTab(
      activeTab === ConfiguratorTabs.PRODUCT_SPECIFICATION
        ? ConfiguratorTabs.TECHNICAL_DESIGN
        : ConfiguratorTabs.PRODUCT_SPECIFICATION,
    );
  }, [setActiveTab, activeTab]);

  return (
    <Button
      data-testid="product-configurator-header_toggle-technical-tab-btn"
      id="technical_design"
      onClick={onClick}
      className="rounded-1 cursor-pointer py-1 fs-18 lh-22 ms-3"
      color="dark"
    >
      {activeTab === ConfiguratorTabs.TECHNICAL_DESIGN
        ? translate("PRODUCT_CONFIGURATOR_PRODUCT_CONFIGURATION")
        : translate("PRODUCT_CONFIGURATOR_TECHNICAL_DESIGN")}
    </Button>
  );
};
